import type { SaveEnvelope } from './types';
import { CURRENT_SCHEMA_VERSION } from './types';

export type MigrationStep = (data: Record<string, unknown>) => Record<string, unknown>;

const MIGRATIONS: Map<number, MigrationStep> = new Map();

/**
 * Daftarkan langkah migrasi schema secara berurutan.
 */
export function registerMigration(fromVersion: number, step: MigrationStep): void {
  MIGRATIONS.set(fromVersion, step);
}

/**
 * Jalankan rantai migrasi dari versi lama hingga CURRENT_SCHEMA_VERSION.
 */
export function migrateEnvelope(rawEnvelope: unknown): { ok: true; envelope: SaveEnvelope } | { ok: false; error: string } {
  if (!rawEnvelope || typeof rawEnvelope !== 'object') {
    return { ok: false, error: 'Envelope bukan objek' };
  }

  let current = JSON.parse(JSON.stringify(rawEnvelope)) as Record<string, unknown>;
  const rawVersion = current.schemaVersion;

  if (typeof rawVersion !== 'number' || !Number.isInteger(rawVersion)) {
    return { ok: false, error: 'schemaVersion tidak valid' };
  }

  let version: number = rawVersion;

  while (version < CURRENT_SCHEMA_VERSION) {
    const step = MIGRATIONS.get(version);
    if (!step) {
      return { ok: false, error: `Tidak ada migrasi dari schemaVersion ${version} ke ${version + 1}` };
    }
    try {
      current = step(current);
      const nextVer = current.schemaVersion;
      if (typeof nextVer !== 'number' || !Number.isInteger(nextVer)) {
        return { ok: false, error: `Hasil migrasi memiliki schemaVersion tidak valid` };
      }
      version = nextVer;
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : 'Unknown migration error';
      return { ok: false, error: `Migrasi v${version} gagal: ${msg}` };
    }
  }

  return { ok: true, envelope: current as unknown as SaveEnvelope };
}

